
export enum ModeType {
	all = "all",
	sm = "sm",
	md = "md",
	lg = "lg",
	xl = "xl",
	'2xl' = "2xl",
	'w-full' = "w-full",
}

export enum SectionType {
	NORMAL = 'normal',
	REUSE = 'reuse',
}

export enum ItemTypeBase {
	TEXT = 'text',
	TEXT_ANCHOR = 'text_anchor',
	CODE = 'code',
	SCRIPT = 'script',
	FAQ = 'faq',
	REUSE = 'reuse',
	SLIDER = 'slider',
	CONTAINER = 'container',
	VIMEO = 'vimeo',
	TABS = 'tabs',
}

export enum ItemWrapperTypeBase {
	HEADER_BOX = 'headerBox',
}

export enum SectionWrapperTypeBase {}

export enum AssetMode {
	Thumb = "thumb",
	Full = "full",
	Media = "media",
}

export enum AssetImageFormat {
	Png = 'png',
	Jpg = 'jpg',
	Webp = 'webp',
	Avif = 'avif'
}

export enum SelectAssetMode {
	ALL = 'all',
	IMAGE = 'image',
}

export enum ContentRenderMode {
	NORMAL = 'normal',
	SLIDER = 'slider',
	REUSE_SECTION = 'reuseSection',
	REUSE_BLOCK = 'reuseBlock'
}
